import { render, staticRenderFns } from "./productPromotionLeadingDialog.vue?vue&type=template&id=5bcdb6c0&scoped=true"
import script from "./productPromotionLeadingDialog.vue?vue&type=script&lang=js"
export * from "./productPromotionLeadingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcdb6c0",
  null
  
)

export default component.exports